module.exports = __webpack_public_path__ + "img/VISA-logo.ce7f05d4.png";